import type { AdvertisementInfoProps } from "./AdvertisementLabel";

export class InfoIcon {
  private readonly iconSvg =
    '<svg width="9" height="9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 22C6.48605 22 2.00005 17.514 2.00005 12C2.00005 6.486 6.48605 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0" clip-rule="evenodd"/><path d="M10.9998 18.0171V10.0096C10.9998 9.4556 11.4467 9.00777 11.9997 9.00777 12.5527 9.00777 12.9997 9.4556 12.9997 10.0096V18.0171C12.9997 18.5711 12.5527 19.0189 11.9997 19.0189 11.4467 19.0189 10.9998 18.5711 10.9998 18.0171zM12.0057 7.01379C11.4527 7.01379 10.9998 6.55995 10.9998 6.00693 10.9998 5.4539 11.4527 5.00006 12.0057 5.00006 12.5587 5.00006 13.0107 5.4539 13.0107 6.00693 13.0107 6.55995 12.5587 7.01379 12.0057 7.01379" clip-rule="evenodd"/></svg>';
  constructor(private readonly props: AdvertisementInfoProps) {}

  render() {
    const parser = new DOMParser();
    const iconElement = parser.parseFromString(
      this.iconSvg,
      "image/svg+xml",
    ).documentElement;

    const removeAlreadyOpenedDialogs = () => {
      const previousDSADialogs = document.querySelectorAll(".dsa-dialog");
      previousDSADialogs.forEach((dialog) => {
        document.body.removeChild(dialog);
      });
    };

    const showDialog = async () => {
      const { AdvertisementInfoDialog } = await import(
        "./AdvertisementInfoDialog"
      );

      removeAlreadyOpenedDialogs();

      const dialog = new AdvertisementInfoDialog(this.props).render();
      document.body.appendChild(dialog);
      dialog.showModal();
    };

    return (
      <span className="dsa-advertisement-label-icon" onClick={showDialog}>
        {iconElement}
      </span>
    );
  }
}
